
import * as React from 'react';
import { MasterModel } from './masterModel';
import { HeaderImage } from './homeModel';

export interface ContactsModel {
    HeaderImage: HeaderImage;
    HeaderText: string;
    PageTypeID: string;
    PageTypeName: string;
    PageID: number;
    PageGroupID: number;
    GroupName: string;
    PageUniqueKey: string;
    PageTitle: string;
    PageName: string;
    PageMetaKeywords: string;
    PageMetaDescription: string;
    LdJson: string;

    IsSubmittingRequest: boolean;
    SubmitRequestSuccessMessage: string;
    SubmitRequestErrorMessage: string;
}

export class SubmitRequestModel {
    YourName: string;
    Email: string;
    Subject: string;
    Message: string;
}


// WEBPACK FOOTER //
// ./ClientApp/app/Models/contactsModel.tsx